<template>
  <div class="img-overlay">
    <remove-from-finding-btn
      v-if="type === 'finding'"
      :findingIndex="findingIndex"
      :imgIndex="imgIndex"
      @click="$emit('removeImgFromFinding')"
    ></remove-from-finding-btn>

    <div class="img-overlay-actions">
      <v-btn flat icon dark @click="downloadImg(`${img.examinationID}/${img.file}`)">
        <v-icon>cloud_download</v-icon>
      </v-btn>
      <v-btn flat icon dark @click="$emit('deleteImg')">
        <v-icon>delete_outline</v-icon>
      </v-btn>
    </div>

    <div class="img-overlay-content">
      <div class="title text-xs-center">Move to</div>
        <div class="findings-list px-2">

        <div v-if="type === 'all'">
          <template
            v-for="findingNum in findingsLength"
          >
            <v-chip
              :key="findingNum" 
              outline 
              color="white" 
              @click="$emit('moveImgFromAllToFinding', findingNum - 1)"
            >Finding {{ findingNum }}</v-chip>
          </template>
        </div>

        <div v-else>
          <template 
            v-for="findingNum in findingsLength"
          >
            <v-chip
              v-if="(findingNum-1) !== findingIndex" 
              :key="findingNum" 
              outline 
              color="white"
              @click="$emit('moveImgBetweenFindings', findingNum - 1)"
            >Finding {{ findingNum }}</v-chip>
          </template>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
	import RemoveFromFindingBtn from '@/components/imgOverlay/removeFromFindingBtn.vue'

	const API_URL = process.env.VUE_APP_API_URL

	export default {
    name: 'ImgOverlay',

    props: {
      type: String,
      data: Object
    },

    components: {
      RemoveFromFindingBtn
    },

    data() {
      return {
      }
    },

    computed: {
     img () {
      return this.data.img
    },

    findingsLength () {
      return this.data.findingsLength
    },

    imgIndex () {
      return this.data.imgIndex
    },

    findingIndex () {
      return this.data.findingIndex
    }
  },

  methods: {
    downloadImg (path) {
      const url = this.prefixServerImgPath(path)
      var $a = document.createElement('a');
      $a.setAttribute("href", url);
      $a.setAttribute("download", "");
      var evObj = document.createEvent('MouseEvents');
      evObj.initMouseEvent( 'click', true, true, window, 0, 0, 0, 0, 0, false, false, true, false, 0, null);
      $a.dispatchEvent(evObj);
    },

    prefixServerImgPath (path) {
      return `${API_URL}/public/upload/image/${path}`
    }
  }
}
</script>